import { render, staticRenderFns } from "./components.vue?vue&type=template&id=4b122d60&scoped=true&"
import script from "./components.vue?vue&type=script&lang=js&"
export * from "./components.vue?vue&type=script&lang=js&"
import style0 from "./components.vue?vue&type=style&index=0&id=4b122d60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b122d60",
  null
  
)

export default component.exports